import React from "react";
import { Switch, Route } from "react-router-dom";

import PageWrapper from "../PageWrapper";
import useRoutes from "../../hooks/useRoutes";
import LazyBoundary from "./components/LazyBoundary";
import PageLoader from "./components/PageLoader";
import useDocumentHeadUpdates from "../../hooks/useDocumentHeadUpdates";
import { useAuthToken } from "../../contexts/AuthTokenContext";
import { PAGE_ROUTES, Login, PageNotFound } from "../../_constants/routes";
import { useAuthRedirect, useGlobalContextSync, useUnauthorizedRedirect } from "./hooks";

const Pages = () => {
  const { routes } = useRoutes();
  const { token } = useAuthToken();

  useDocumentHeadUpdates();
  useAuthRedirect();
  useUnauthorizedRedirect();
  useGlobalContextSync();

  return (
    <Switch>
      <Route path={routes.login.url}>
        <LazyBoundary>
          <Login />
        </LazyBoundary>
      </Route>

      {/* `useAuthRedirect` bounces a tokenless visitor to /login, but it does that in an effect —
          which runs *after* its children have mounted and fired their own mount-time effects. So
          every authenticated page used to get one render and one round of requests on a cold
          unauthenticated load, only to be unmounted a moment later; `useApi` then aborted them and
          the rejections surfaced as console noise (Dashboard's suspended-instruments fetch was the
          visible one). Holding the tree back until there is a token is what makes the redirect
          happen before the requests rather than after. */}
      <Route>
        {token ? (
          <PageWrapper>
            {/* Inside PageWrapper so navigation and the header stay mounted while a
                route chunk is in flight. */}
            <LazyBoundary>
              <Switch>
                {PAGE_ROUTES.map(({ path, exact, Page }) => (
                  <Route key={path} path={path} exact={exact}>
                    <Page />
                  </Route>
                ))}
                <Route>
                  <PageNotFound />
                </Route>
              </Switch>
            </LazyBoundary>
          </PageWrapper>
        ) : (
          <PageLoader />
        )}
      </Route>
    </Switch>
  );
};

export default Pages;
